import styles from './Accordion.module.scss';
import { Children, useRef } from 'react';
import PropTypes from 'prop-types';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import { useToggleState } from 'react-stately';
import { FocusScope, useToggleButton } from 'react-aria';
import Icon from '@mdi/react';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

const Accordion = ({ titleClassName, variant = 'default', numberAboveFold, sticky = false, title, ...props }) => {
    const ref = useRef();
    const state = useToggleState(props);
    const { buttonProps } = useToggleButton({
        ...props,
        elementType: 'div'
    }, state, ref);

    const { isSelected } = state;
    const items = Children.toArray(props.children);
    const isButton = items.length > numberAboveFold;
    const isSticky = sticky && isButton && isSelected;

    return <div className={styles.container}>
        <button ref={ref}
            {...(isButton ? buttonProps : {})}
            aria-expanded={isSelected ? 'true' : 'false'}
            className={[
                styles.button,
                isSticky ? styles.stickyHeader : null,
                titleClassName,
                variant === 'bare' ? styles.buttonBare : null
            ].join(' ')}>
            {title}
            {isButton && variant !== 'bare'
                ? <div className={styles.chevron}>
                    <Icon
                        path={isSelected ? mdiChevronUp : mdiChevronDown}
                        size={1.1}
                    />
                </div>
                : null}
        </button>
        <FocusScope>
            <div data-testid={props['data-testid'] ? props['data-testid'] + '.content' : null} className={styles.content}>
                {items.slice(0, numberAboveFold)}
                {isSelected && items.slice(numberAboveFold)}
            </div>
        </FocusScope>
    </div>;
};

Accordion.propTypes = {
    ...defaultAriaProps,
    'data-testid': PropTypes.string,
    titleClassName: PropTypes.string,
    numberAboveFold: PropTypes.number,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
    variant: PropTypes.oneOf(['bare', 'default'])
};

Accordion.defaultProps = {
    titleClassName: '',
    numberAboveFold: 0,
    variant: 'default'
};

export default Accordion;
